export default "__VITE_ASSET__CfnitYdF__"